import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { IndexLink } from 'react-router';
import _ from 'lodash';
import { LinkContainer } from 'react-router-bootstrap';
import Navbar from 'react-bootstrap/lib/Navbar';
import Nav from 'react-bootstrap/lib/Nav';
import NavItem from 'react-bootstrap/lib/NavItem';
import { connect } from 'react-redux';
import { getDeployment } from '../redux/modules/deployment';
import { AuthContext } from '../components/Auth';

export class Header extends Component {
  static propTypes = {
    pathname: PropTypes.string.isRequired,
    getDeployment: PropTypes.func.isRequired,
    user: PropTypes.object,
  };

  static defaultProps = {
    user: null,
  };

  componentDidMount() {
    const { getDeployment } = this.props;
    getDeployment();
  }

  static contextType = AuthContext;

  render() {
    const { user, pathname, version } = this.props;
    const { logout } = this.context;

    return (
      <header>
        <Navbar fixedTop>
          <Navbar.Header>
            <Navbar.Brand>
              <IndexLink to="/">
                <span title={`Version ${version}`}>PRco E-Sign API Admin</span>
              </IndexLink>
            </Navbar.Brand>
            <Navbar.Toggle />
          </Navbar.Header>

          <Navbar.Collapse>
            <Nav navbar pullRight>
              {user && pathname !== '/' && (
                <LinkContainer to="/" active={false}>
                  <NavItem>Back to Dashboard</NavItem>
                </LinkContainer>
              )}
              {user && (
                <LinkContainer to="/" active={false}>
                  <NavItem onClick={logout}>Logout</NavItem>
                </LinkContainer>
              )}
            </Nav>
          </Navbar.Collapse>
        </Navbar>
      </header>
    );
  }
}

export default connect(
  ({ auth, deployment, routing }) => ({
    user: auth.user,
    version: _.get(deployment, 'version', 'N/A'),
    pathname: _.get(routing, 'locationBeforeTransitions.pathname'),
  }),
  { getDeployment },
)(Header);



// WEBPACK FOOTER //
// ./src/components/Header.js